export const CAPACITY = 'Capacidad:';
export const COLOR = 'Color:';

export const MAIN_CHARACTERISTICS = 'Características principales';
export const RETAIL = 'Al detalle';
export const VIEW_SPEC = 'Ver especificaciones técnicas del';

export const NIE_NIF_PASSPORT_REGEX = new RegExp(/^(?:(?:[XYZ]\d{7,8}[A-Z])|(?:\d{8}[A-Z])|(?:[A-Z]{2}\d{7}))$/);
export const TEL_REGEX = new RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{3})$/);
export const EMAIL_REGEX = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);

export const BALIZA_CONDITIONS = `<div class="tech-specs" aria-labelledby="specs-title">
          <h2><strong>Condiciones</strong></h2>
          <p>El contrato de arrendamiento tiene una duración de 48 meses. Al finalizar el periodo podrás comprar el dispositivo por 1€. Descarga todas las condiciones desde <a class="const-link" href="https://prod.adb.col.movistar.es/content/dam/movistar/contratos/015_COL_CAST_CCEsp_Arrendamiento_Dispositivos_Movistar.pdf" target="_blank">aquí</a>.</p>
        </div>`